import { render, staticRenderFns } from "./DiarySkeleton.vue?vue&type=template&id=45dea0a6&scoped=true"
import script from "./DiarySkeleton.vue?vue&type=script&lang=js"
export * from "./DiarySkeleton.vue?vue&type=script&lang=js"
import style0 from "./DiarySkeleton.vue?vue&type=style&index=0&id=45dea0a6&prod&scoped=true&lang=css"
import style1 from "./DiarySkeleton.vue?vue&type=style&index=1&id=45dea0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dea0a6",
  null
  
)

export default component.exports